module.exports = __webpack_public_path__ + "img/Paypal.aee0300a.png";